import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';

export const MuiDialogContent: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: {
      paddingBottom: 0,
      '& .MuiDialogContentText-root': {
        marginBottom: '24px',
      },
    },
  },
};
